import { TablePropertiesState, TablePropertiesAction, TablePropertiesActionTypes } from '../types';

export default (state: TablePropertiesState = {}, action: TablePropertiesActionTypes) => {
  const newState = { ...state };
  switch (action.type) {
    case TablePropertiesAction.REPLACE_TABLE_PROPERTIES:
      newState[action.scope] = {};
      if (action.orderColumn) {
        newState[action.scope].orderColumn = action.orderColumn;
      }
      if (action.pinnedRows) {
        newState[action.scope].pinnedRows = action.pinnedRows;
      }
      if (action.selectedRows) {
        newState[action.scope].selectedRows = action.selectedRows;
      }
      return newState;
    case TablePropertiesAction.CHANGE_TABLE_PROPERTIES:
      if (!newState[action.scope]) {
        newState[action.scope] = {};
      }
      if (action.orderColumn !== undefined) { // can be zero
        newState[action.scope].orderColumn = action.orderColumn;
      }
      if (action.pinnedRows) {
        newState[action.scope].pinnedRows = action.pinnedRows;
      }
      if (action.selectedRows) {
        newState[action.scope].selectedRows = action.selectedRows;
      }
      if (action.scroll) {
        newState[action.scope].scroll = action.scroll;
      }
      return newState;
    default:
      return state;
  }
};
